<p class="editor__data-grid--empty" *ngIf="!isEditable() && !lastSignedUserAgreementsSig()?.length; else dataGridTmp">
  {{ emptyMessage }}
</p>

<ng-template #dataGridTmp>
  <dx-data-grid
    #userAgreementsGridRef
    class="editor editor__data-grid"
    [class.editor__data-grid--view]="!isEditable()"
    [dataSource]="lastSignedUserAgreementsSig()"
    [showRowLines]="isEditable()"
    [showBorders]="isEditable()"
    [showColumnLines]="isEditable()"
    [showColumnHeaders]="true"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="isEditable()"
    [rowAlternationEnabled]="false"
    [noDataText]="emptyMessage"
    (onInitNewRow)="onInitNewRow($event)"
    height="100%"
  >
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-scrolling [mode]="'virtual'" [showScrollbar]="'always'"></dxo-scrolling>

    <dxo-toolbar [visible]="canCreate()">
      <dxi-button name="add"></dxi-button>
    </dxo-toolbar>

    <dxo-editing
      mode="popup"
      [useIcons]="true"
      [allowUpdating]="false"
      [allowDeleting]="false"
      [allowAdding]="false"
    ></dxo-editing>

    <dxi-column
      [dataField]="PolicySignersKeys.policyType"
      caption=""
      [width]="150"
    >
      <dxo-lookup
        [dataSource]="POLICY_TYPES_LOOKUP"
        [valueExpr]="LookupKeys.value"
        [displayExpr]="LookupKeys.description"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column
      [dataField]="'currentVersion'"
      caption="Current Version"
      [width]="150"
      cellTemplate="currentVersionCellTemplate"
    ></dxi-column>

    <dxi-column
      [dataField]="PolicySignersKeys.policyVersion"
      caption="Signed Version"
      [width]="150"
      cellTemplate="lastSignedVersionCellTemplate"
    ></dxi-column>

    <dxi-column
      [dataField]="BaseModelKeys.updatedDate"
      caption="Date of Signing"
      [allowEditing]="false"
      [dataType]="'date'"
      [format]="dateFormat"
      [width]="150"
      cellTemplate="dateOfLastSigningCellTemplate"
    ></dxi-column>

    <dxi-column
      [dataField]="'sourceFileKey'"
      caption="Signed Document"
      cellTemplate="sourceFileKeyCellTemplate"
      alignment="center"
      [allowGrouping]="false"
    ></dxi-column>

    <!-- Templates-->
    <div *dxTemplate="let cell of 'currentVersionCellTemplate'">
      <span *var="(currentUserAgreements$ | async) as currentVersion">
        {{ currentVersion?.[cell?.data?.[PolicySignersKeys.policyType]] | empty }}
      </span>
    </div>

    <div *dxTemplate="let cell of 'lastSignedVersionCellTemplate'">
      {{ cell.value | empty }}
    </div>

    <div *dxTemplate="let cell of 'dateOfLastSigningCellTemplate'">
      {{ cell.value | date: dateFormat | empty }}
    </div>

    <div *dxTemplate="let cell of 'sourceFileKeyCellTemplate'">
      <dx-button
        class="ag-custom-button"
        icon="agi-zip"
        hint="Download zip"
        stylingMode="text"
        [visible]="!!cell?.data?.[PolicySignersKeys.policyVersion]"
        [disabled]="!!loadingPdfSig()"
        (onClick)="downloadPdf(cell.data)"
      ></dx-button>
    </div>
  </dx-data-grid>
</ng-template>
